module.exports = __webpack_public_path__ + "static/media/completed_task__isometric.06bac95d.svg";